/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * UserAddDTO.ts
 */

import {Type} from "../../../tools/view/form/FormInput";
import Translation from "../../../services/translation/Translation";
import {AbstractForm} from "../../../tools/model/form/AbstractForm";
import User from "../../User";
import {UserActivationDTO} from "../../dto/user/UserActivationDTO";
import {CheckboxField} from "../../../tools/model/form/CheckboxField";

export default class UserActivationForm extends AbstractForm<UserActivationDTO> {
    constructor(user: User) {
        super();

        this.fields.set(UserActivationDTO.ENABLED, new CheckboxField(
            UserActivationDTO.ENABLED,
            (t: Translation) => t.clientListColEnabled,
            () => true,
            Type.CHECKBOX,
            true,
            user.enabled,
            user.enabled
        ));

        this.load(UserActivationDTO.fromUser(user));
    }
}
